import { FilterMatchMode } from 'primereact/api';

export const tableFilters = {
  tipoLiquidacion: { value: null, matchMode: FilterMatchMode.CONTAINS },
  numeroDeLiquidacion: { value: null, matchMode: FilterMatchMode.CONTAINS },
  observacionesLiquidacion: {
    value: null,
    matchMode: FilterMatchMode.CONTAINS,
  },
  contenedor: { value: null, matchMode: FilterMatchMode.CONTAINS },
  armador: { value: null, matchMode: FilterMatchMode.CONTAINS },
  numero: { value: null, matchMode: FilterMatchMode.CONTAINS },
  importe: { value: null, matchMode: FilterMatchMode.CONTAINS },
  fechaDocumento: { value: null, matchMode: FilterMatchMode.DATE_IS },
  vencimiento: { value: null, matchMode: FilterMatchMode.DATE_IS },
  cliente: { value: null, matchMode: FilterMatchMode.CONTAINS },
};
